<template>
	<div class="social-login">
		<button type="button" class="btn btn-google btn-block" @click="loginGoogle">
			<span>SIGN IN WITH GOOGLE</span>
			<i class="fab fa-google"></i>
		</button>
		<button type="button" class="btn btn-facebook btn-block" @click="loginFacebook">
			<span>SIGN IN WITH FACEBOOK</span>
			<i class="fab fa-facebook-square"></i>
		</button>
	</div>
</template>

<script>
export default {
	methods: {
		loginGoogle() {
			this.$repo.socialLogin.loginGoogle().then((data) => {
				this.$emit('loggedin', data);
			});
		},
		loginFacebook() {
			this.$repo.socialLogin.loginFacebook().then((data) => {
				this.$emit('loggedin', data);
			});
		},
	},
};
</script>

<style lang="scss">
.social-login {
	.btn-google,
	.btn-facebook {
		display: flex;
		justify-content: space-between;
		align-items: center;

		font-size: 14px;
		border-radius: 5px;
	}

	.btn-google {
		background-color: #eb4335;
	}

	.btn-facebook {
		background-color: #475993;
	}
}
</style>
